module.exports = __webpack_public_path__ + "img/outdent.bb84ba6b.svg";